export default __webpack_public_path__ + "static/media/help--setup-google.c1bea2dc.png";